import { object, array } from 'yup';
import gql from 'graphql-tag';

import * as transforms from './transforms';
import { string } from './rules';

export default {
  type: 'Role',
  schema: object().shape({
    name: string('Name', true),
    title: string('Title', true),
    description: string('Descripption', false),
    permissions: array(),
    roles: array(),
  }),
  transforms: {
    roles: transforms.roles('id'),
    permissions: {
      formValueToMutationArg: {
        postValidation: (value, fieldName, fields, doc) => ({ set: value }),
      },
    },
  },
  fragments: {
    default: gql`
      fragment RoleDefaultFragment on Role{
        id
        name
        title
        description
        permissions
        roles{
          id
          name
          title
          description
          permissions
          roles{
            id
            name
            title
            description
            permissions
            roles{
              id
              name
              title
              description
              permissions
              roles{
                id
                name
                title
                description
                permissions
                roles{
                  id
                  name
                  title
                  description
                  permissions
                }
              }
            }
          }
        }
      }
    `,
  },
};
